import Link from 'next/link';

import {
  CompetitionLogo,
  competitionLogoFragment,
} from '@/components/CompetitionLogo';
import { MatchdayCardDate } from '@/components/MatchdayCardDate';
import { matchdayCardDateFragment } from '@/components/matchdayCardDateFragment';
import {
  MatchdayLeaderboard,
  matchdayLeaderboardFragment,
} from '@/components/MatchdayLeaderboard';
import { getCompetitionName, getMatchdayUrl } from '@/utils';
import { graphql } from '@/utils/graphql';
import { FragmentOf, readFragment } from 'gql.tada';

export const homeMatchdayCardFragment = graphql(
  `
    fragment homeMatchdayCardFields on matchdays {
      slug
      name
      season {
        slug
        name
        competition {
          slug
          name
          ...competitionLogoFields
          parent {
            name
          }
        }
      }
      ...matchdayCardDateFields
      ...matchdayLeaderboardFields
    }
  `,
  [
    competitionLogoFragment,
    matchdayCardDateFragment,
    matchdayLeaderboardFragment,
  ],
);

export function HomeMatchdayCard({
  matchday: _matchday,
}: {
  matchday: FragmentOf<typeof homeMatchdayCardFragment>;
}) {
  const matchday = readFragment(homeMatchdayCardFragment, _matchday);

  const name = getCompetitionName(matchday.season!.competition!);

  return (
    <div className="flex flex-row items-center py-3 px-4 md:px-8 relative hover:bg-accent">
      <div className="w-8 min-w-8 box-content mr-4 md:mr-8 z-10">
        <MatchdayCardDate matchday={matchday} />
      </div>
      <div className="pr-3">
        <CompetitionLogo
          competition={matchday.season!.competition!}
          options={{ width: 48, height: 48 }}
        />
      </div>
      <div className="flex-1 min-w-0">
        <Link
          href={getMatchdayUrl(
            matchday.season!.competition!,
            matchday.season!,
            matchday,
          )}
          className="after:absolute after:inset-0"
          prefetch={false}
        >
          <div className="font-medium truncate">{name}</div>
          <div className="text-sm truncate">{matchday.name}</div>
        </Link>
      </div>
      <MatchdayLeaderboard matchday={matchday} />
    </div>
  );
}
